const prefix = "cermaq_local_";

export const LOCAL_NEW_IMAGES = prefix + "new_images";
export const LOCAL_NEW_FORMS = prefix + "new_forms";
export const LOCAL_UPDATED_FORMS = prefix + "updated_forms";
export const LOCAL_UPDATED_IMAGES = prefix + "updated_images";
export const LOCAL_MY_INSPECTIONS = prefix + "my_inspections";
export const LOCAL_ALL_INSPECTIONS = prefix + "all_inspections";
export const LOCAL_FORMS_AD = prefix + "forms_ad";
export const LOCAL_FORMS_AM = prefix + "forms_am";
export const LOCAL_FORMS_P = prefix + "forms_p";
export const LOCAL_FORMS_ADMIN = prefix + "forms_adm";
export const LOCAL_FORMS_OPTIONS = prefix + "forms_options";
export const LOCAL_HELP = prefix + "help";
export const LOCAL_SESSION = prefix + "app_session";
export const LOCAL_TOKEN = prefix + "jwt_token";

export const LOCAL_PREFIX = prefix;
